export enum LocalStorageKey {
  hasVisited = 'HAS_VISITED',
  cookieBannerDisplayed = 'COOKIE_BANNER_DISPLAYED',
  // No longer written (NEXUS-2384); only removed from browsers that stored it before
  legacyAuthenticatorAccessToken = 'PMC_AUTHENTICATOR_ACCESS_TOKEN',

  // Guest uuid left by the TIO migration, merged into the account on sign-in
  tioGuestUuid = 'uuid',
}
